<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sale Returns Report Today",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },

  data() {
    return {
      filterTitle: "Sale Returns Report",
      data: {
        datefrom: "",
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        product: "",
        page: 1,
        per_page: 50,
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Sale Returns Report Today",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Sale Returns Report Today",
          active: true,
        },
      ],
      totalRows: 1,

      filteredReport: [],
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsSalesReturnServerPaginated: true,
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "qty",
          sortable: false,
          label: "QUANTITY",
        },
        {
          key: "SPrice",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT REFUNDED",
        },
        {
          key: "reason",
          sortable: true,
          label: "REASON",
        },
        {
          key: "status",
          sortable: true,
          label: "STATUS",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "action",
          sortable: true,
          label: "ACTION",
        },
      ],
      json_fields: {
        PRODUCT_NAME: "product",
        QUANTITY: "qty",
        UNIT_PRICE: "SPrice_no",
        AMOUNT_REFUNDED: "amount",
        MODE: "mode",
        REASON: "reason",
        DATE: "date",
        RECORDED_BY: "user",
        RECORDED_ON: "addedon",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

      // cancel return
      canceldata: {
        name: "",
        product: "",
        id: "",
      },

      // retry return
      retrydata: {
        name: "",
        product: "",
        id: "",
      },
      modal_id: "",
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("sales", [
      "SalesReturn",
      "SaveSaleStatus",
      "SalesReturnPagination",
      "SalesReturnPaginated",
      "SalesReturnSummary",
      "filterStatus",
    ]),
    ...mapGetters("products", ["Products"]),

    rows() {
      return this.IsSalesReturnServerPaginated
        ? this.SalesReturnPagination?.total
        : this.SalesReturnPaginated
        ? this.SalesReturnPaginated.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsSalesReturnServerPaginated) {
          const value =
            this.SalesReturnPagination?.per_page ||
            this.data.per_page ||
            this.serverPerPage;
          return parseInt(value) || this.serverPerPage;
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsSalesReturnServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchReturns(this.data);
        }
      },
    },

    currentPage: {
      get() {
        return this.SalesReturnPaginated && this.SalesReturnPagination
          ? this.SalesReturnPagination.current_page
          : 1;
      },
      set(value) {
        if (this.SalesReturnPaginated) {
          this.data.page = value;
          this.FetchReturns(this.data);
        }
      },
    },

    totals() {
      return (
        this.SalesReturnSummary || {
          total_amount_refunded: 0,
        }
      );
    },
  },

  methods: {
    ...mapActions({
      FetchReturns: "sales/fetchReturns",
      FetchProducts: "products/fetchProducts",
      CancelReturn: "sales/CancelReturn",
      RetryReturn: "sales/RetryReturn",
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m === "" || m === undefined || m === null) {
        return m;
      }
      const str = m.toString();
      const integerPart = str.split(".")[0];
      return integerPart
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    filterReport() {
     let payload = { ...this.data };

      payload.page = 1;
      // Keep the current per_page value instead of resetting to serverPerPage
      if (!payload.per_page) {
        payload.per_page = this.serverPerPage;
      }

      this.FetchReturns(payload);
    },

    showRetryModal(data) {
      this.retrydata.name = data.item.product;
      this.retrydata.product = data.item.product_id;
      this.retrydata.id = data.item.id;
    },

    showCancelModal(data) {
      this.canceldata.name = data.item.product;
      this.canceldata.product = data.item.product_id;
      this.canceldata.id = data.item.id;
    },

    resetCancel() {
      this.canceldata.product = "";
      this.canceldata.name = "";
      this.canceldata.id = "";
      this.modal_id = "";
    },
    resetRetry() {
      this.retrydata.product = "";
      this.retrydata.name = "";
      this.retrydata.id = "";
      this.modal_id = "";
    },

    cancelReturn(modalId) {
      this.modal_id = modalId;
      this.CancelReturn(this.canceldata);
    },

    retryReturn(modalId) {
      this.modal_id = modalId;
      this.RetryReturn(this.retrydata);
    },

    //== close modal
    closeModal(modalId) {
      this.resetRetry();
      this.resetCancel();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    redirect(value) {
      this.$router.push(`/sales/view_salereturns/${btoa(value)}`);
    },
    handlePageChange(newPage) {
      if (this.IsSalesReturnServerPaginated) {
        this.data.page = newPage;
        this.FetchReturns(this.data);
      }
    },
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          this.closeModal(this.modal_id);
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  created() {
    this.FetchReturns(this.data);
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3
                  class="card-title mb-2 text-center"
                  v-html="filterTitle"
                ></h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-info"
                  :data="filteredReport"
                  :fields="json_fields"
                  :worksheet="'PURCHASE RETUNRS REPORT ON' + currentdate"
                  type="csv"
                  :name="'Purchase_returns' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input v-model="data.dateto" type="date" class="form-control" v-limit-future-date/>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>Product</label>
                  <model-list-select
                    :list="
                      Products
                        ? [{ id: '', name: 'All Products' }, ...Products]
                        : []
                    "
                    v-model="data.product"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Product"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-1 mt-4">
                <button
                  class="btn btn-primary cursor-pointer"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-filter cursor-pointer"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="fields"
                :rows="SalesReturn || []"
                :total-rows="rows"
                :pagination="SalesReturnPagination"
                :server-pagination="IsSalesReturnServerPaginated"
                :loading="filterStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(amount)="{ row }">
                  {{ (row.amount || 0).toLocaleString("en-US") }}
                </template>

                <template #cell(status)="{ row }">
                  <div>
                    <span
                      class="text-warning"
                      v-if="row.refno && row.status == '0'"
                      >Pending</span
                    >
                    <span
                      class="text-success"
                      v-if="row.refno && row.status == '1'"
                      >Approved</span
                    >
                    <span
                      class="text-danger"
                      v-if="row.refno && row.status == '2'"
                      >Rejected</span
                    >
                    <span
                      class="text-info"
                      v-if="row.refno && row.status == '3'"
                      >Voided</span
                    >
                    <span v-if="!row.refno"
                      >Unsynchronised
                      <b-button
                        size="sm"
                        variant="success"
                        v-b-modal.retry-modal
                        @click="showRetryModal({ item: row })"
                        >Retry</b-button
                      >
                    </span>
                  </div>
                </template>
                <template #cell(action)="{ row }">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.cancel-modal
                      @click="showCancelModal({ item: row })"
                      ><i class="fa fa-trash"></i>Cancel</b-button
                    >
                    <b-button
                      size="sm"
                      variant="info"
                      v-b-modal.view-modal
                      @click="redirect(row.id)"
                      ><i class="fa fa-eye"></i>View</b-button
                    >
                  </b-button-group>
                </template>
                <template #cell(product)="{ row }">
                  <div v-for="(i, idx) in row.items" :key="idx" class="mb-4">
                    {{ i.product.product_name }}
                  </div>
                </template>
                <template #cell(qty)="{ row }">
                  <div v-for="(i, idx) in row.items" :key="idx" class="mb-4">
                    {{ i.qty + (i.usymbol || "") }}
                  </div>
                </template>
                <template #cell(SPrice)="{ row }">
                  <div v-for="(i, idx) in row.items" :key="idx" class="mb-4">
                    {{ i.SPrice ? thousandSeperator(i.SPrice) : 0 }}
                  </div>
                </template>
              </DataTable>
              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-6">
                  <h5>
                    Total Amount Refunded:
                    <span class="text-danger">{{
                      thousandSeperator(totals.total_amount_refunded)
                    }}</span>
                  </h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal delete product starts -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="cancel-modal"
      hide-footer
      @hidden="resetCancel"
    >
      <template #modal-title> Cancel Return for {{ canceldata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to cancel this Return? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('cancel-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="cancelReturn('cancel-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveSaleStatus"
            variant="light"
            small
            label="Canceling"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete product starts -->
    <b-modal
      header-bg-variant="success"
      header-text-variant="light"
      body-text-variant="success"
      footer-bg-variant="success"
      footer-text-variant="success"
      id="retry-modal"
      hide-footer
      @hidden="resetRetry"
    >
      <template #modal-title> Retry Return for {{ retrydata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to cancel this Return? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('retry-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="retryReturn('retry-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveSaleStatus"
            variant="light"
            small
            label="Retrying"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
